import { Component, Input } from '@angular/core'

import { IconComponent } from '../../icon/icon.component'

@Component({
  selector: 'sb-media-placeholder',
  templateUrl: './placeholder.component.html',
  styleUrls: ['./placeholder.component.scss'],
  imports: [IconComponent],
})
export class MediaPlaceholderComponent {
  @Input() isSecret = false
  @Input() isVideo = false
  @Input() isMessagePhoto = false
}
